<template>
  <div
    class="heat-metering"
    v-loading="loading"
    element-loading-text="正在查询信息，请稍后~"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    element-loading-spinner="el-icon-loading"
  >
    <div class="heat-metering-back"></div>
    <div v-if="showTip == 1">
      <div class="heat-metering-info">
        <div class="heat-metering-top">
          <div>
            <div style="padding: 0.2rem 0rem 0.05rem 0.2rem">
              <div>房屋卡号：{{ hourseInfo.heating_card_num }}</div>
            </div>
            <div style="padding: 0.05rem 0rem 0.2rem 0.2rem">
              <div>房屋地址：{{ hourseInfo.address }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="data-tip">您所居住的房屋{{ hourseInfo.charging_period }}年度热计量读数如下:</div>
      <div class="heat-metering-data">
        <div class="data-item">
          <span>期初读数（kwh）</span>
          <span>{{ hourseInfo.initial_heat }}</span>
        </div>
        <div class="data-item">
          <span>期末读数（kwh）</span>
          <span>{{ hourseInfo.final_heat }}</span>
        </div>
        <div class="data-item">
          <span>用热量（kwh）</span>
          <span>{{ hourseInfo.total_heat }}</span>
        </div>
      </div>
      <div class="table-tip">
        该数据仅供用户核对，如有疑义可拨打我公司客服电话966011咨询核实，最终耗热量和热费金额以我公司收费系统结算为准。
      </div>
      <div class="heat-metering-table">
        <div class="table-header table-item-style">居民用热计费方式和单价</div>
        <div class="table-item-style" style="height: 0.33rem; border-bottom: 1px solid #dddddd">
          <div
            class="table-item-style"
            style="
              height: 100%;
              width: 0.88rem;
              padding-left: 0.125rem;
              border-right: 1px solid #cccccc;
            "
          >
            计费方式
          </div>
          <div class="table-item-style" style="height: 100%; padding-left: 0.125rem">计费办法</div>
        </div>
        <div class="table-item-style" style="height: 0.45rem; border-bottom: 1px solid #dddddd">
          <div
            class="table-item-style"
            style="
              height: 100%;
              width: 0.88rem;
              padding-left: 0.125rem;
              border-right: 1px solid #cccccc;
            "
          >
            面积
          </div>
          <div class="table-item-style" style="height: 100%; padding-left: 0.125rem">
            收费面积×23（元/㎡）
          </div>
        </div>
        <div class="table-item-style" style="height: 0.58rem; border-bottom: 1px solid #dddddd">
          <div
            class="table-item-style"
            style="
              height: 100%;
              width: 0.88rem;
              padding-left: 0.125rem;
              border-right: 1px solid #cccccc;
            "
          >
            热计量
          </div>
          <div class="table-item-style" style="height: 100%; padding-left: 0.125rem">
            收费面积×23（元/㎡）×30%+耗热量×0.188（元/Kwh)
          </div>
        </div>
        <div class="table-header table-item-style">非居民用热计费方式和单价</div>
        <div class="table-item-style" style="height: 0.33rem; border-bottom: 1px solid #dddddd">
          <div
            class="table-item-style"
            style="
              height: 100%;
              width: 0.88rem;
              padding-left: 0.125rem;
              border-right: 1px solid #cccccc;
            "
          >
            计费方式
          </div>
          <div class="table-item-style" style="height: 100%; padding-left: 0.125rem">计费办法</div>
        </div>
        <div class="table-item-style" style="height: 0.61rem; border-bottom: 1px solid #dddddd">
          <div
            class="table-item-style"
            style="
              height: 100%;
              width: 0.88rem;
              padding-left: 0.125rem;
              border-right: 1px solid #cccccc;
            "
          >
            面积
          </div>
          <div class="table-item-style" style="height: 100%; padding-left: 0.125rem">
            收费面积×32（元/㎡），用户层高超过3米的，采暖面积=建筑面积X（超高高度X1/3+1)
          </div>
        </div>
        <div class="table-item-style" style="height: 0.6rem; border-bottom: 1px solid #dddddd">
          <div
            class="table-item-style"
            style="
              height: 100%;
              width: 0.88rem;
              padding-left: 0.125rem;
              border-right: 1px solid #cccccc;
            "
          >
            热计量
          </div>
          <div class="table-item-style" style="height: 100%; padding-left: 0.125rem">
            收费面积×32（元/㎡）×30%+耗热量×0.298（元/Kwh)
          </div>
        </div>
        <!-- <table align="center" border="1" cellspacing="0">
          <tr align="center">
            <td>房屋用途</td>
            <td>计费方式</td>
            <td>计费办法</td>
          </tr>
          <tr align="center">
            <td rowspan="2">居民</td>
            <td>面积</td>
            <td>收费面积×23（元/㎡）</td>
          </tr>
          <tr align="center">
            <td>热计量</td>
            <td>收费面积×23（元/㎡）×30%+耗热量×0.188（元/Kwh)</td>
          </tr>
          <tr align="center">
            <td rowspan="2">非居民</td>
            <td>面积</td>
            <td>收费面积×32（元/㎡），用户层高超过3米的，采暖面积=建筑面积X（超高高度X1/3+1)</td>
          </tr>
          <tr align="center">
            <td>热计量</td>
            <td>收费面积×32（元/㎡）×30%+耗热量×0.298（元/Kwh)</td>
          </tr>
        </table> -->
      </div>
    </div>
    <div class="tip-wrap" v-if="showTip == 2">
      <div class="tip-top">
        <div class="tip-box">
          非热计量用户、热计量停热用户、热表有故障的用户，可能无法获取相关数据，具体情况请致电966011客服电话咨询。
        </div>
      </div>
      <div class="tip-bottom">
        <el-button
          type="primary"
          style="background: #007b83; color: #fff; border: none; width: 2.7rem; padding: 4%"
          @click="goHome"
          >确认</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      showTip: 0,
      hourseInfo: null,
    };
  },
  mounted() {
    document.title = '热计量公示';
    this.getHeatPublicInfo();
  },
  methods: {
    handleCancelClick() {
      this.$router.replace({
        name: 'index',
      });
    },
    goHome() {
      this.$router.replace({
        name: 'index',
      });
    },
    // 获取信息
    async getHeatPublicInfo() {
      this.loading = true;
      const res = await this.$http.get(`${this.$url.globalurl}/wxHeatPublic`);
      console.log(res);
      this.loading = false;
      if (res.result) {
        this.hourseInfo = res.result;
        this.showTip = 1;
      } else {
        this.showTip = 2;
      }
    },
  },
};
</script>
<style scoped>
@import url(heatMetering.scss);
</style>

